// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__3L5Pi","items":"Header_items__1miR7","notification":"Header_notification__2V-x1","language":"Header_language__1emyo"};